import { Link } from "react-router-dom";

/**
 * Shared layout for /terms, /privacy, /refund.
 * Plain, professional, gateway-verification-friendly.
 * The company/contact metadata is sourced from a single constant so all three
 * pages stay in lockstep — change once, all three update.
 */

export const LEGAL = {
  brand: "Reply Rescue",
  site: "replyrescue.app",
  contactEmail: "support@replyrescue.app",
  effectiveDate: "1 February 2026",
};

export default function LegalLayout({ title, lastUpdated, children, testid }) {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#E8ECEF]" dir="ltr" data-testid={testid}>
      <header className="border-b border-white/10">
        <div className="max-w-3xl mx-auto px-6 py-5 flex items-center justify-between">
          <Link to="/" className="text-[14px] font-bold text-white hover:text-[#C9A66A] transition-colors">
            {LEGAL.brand}
          </Link>
          <nav className="flex items-center gap-5 text-[12.5px] text-[#9AA5B1]">
            <Link to="/legal/terms" className="hover:text-white transition-colors">Terms</Link>
            <Link to="/legal/privacy" className="hover:text-white transition-colors">Privacy</Link>
            <Link to="/legal/refund" className="hover:text-white transition-colors">Refund</Link>
          </nav>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-12 sm:py-16">
        <div className="text-[11px] tracking-[0.28em] text-[#C9A66A] font-bold mb-3">LEGAL</div>
        <h1 className="text-[28px] sm:text-[36px] font-extrabold text-white leading-tight mb-2">{title}</h1>
        <p className="text-[12.5px] text-[#6B7480] mb-10">Last updated: {lastUpdated || LEGAL.effectiveDate}</p>
        <article className="space-y-7 text-[14.5px] text-[#CFD3D7] leading-[1.85]">
          {children}
        </article>
        <footer className="mt-16 pt-8 border-t border-white/10 text-[12px] text-[#6B7480]">
          © {new Date().getFullYear()} {LEGAL.brand}. Contact: <a href={`mailto:${LEGAL.contactEmail}`} className="text-[#C9A66A] hover:text-white transition-colors">{LEGAL.contactEmail}</a>
        </footer>
      </main>
    </div>
  );
}

export const Section = ({ id, title, children }) => (
  <section id={id} data-testid={`legal-section-${id}`}>
    <h2 className="text-[18px] sm:text-[20px] font-bold text-white mt-2 mb-3">{title}</h2>
    <div className="space-y-3">{children}</div>
  </section>
);
